import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Select } from "antd";
import styles from "./IntroduccioObservador.module.css";
import { omplirIdObservadorIntroduccio } from "../../actions";
import {
  getIdObservadorIntroduccio,
  getObservadorsAsArray
} from "../../reducers";

class IntroduccioObservador extends Component {
  handleOnChange = opcioSeleccionada => {
    const idObservador = opcioSeleccionada.substr(
      opcioSeleccionada.indexOf("#&") + 2
    );
    const constIdObservadorInt = isNaN(parseInt(idObservador))
      ? 0
      : parseInt(idObservador);

    const { onChange, omplirIdObservadorIntroduccio } = this.props;
    omplirIdObservadorIntroduccio(constIdObservadorInt);
    onChange();
  };

  ordenarArrayObjectesDesc = (a, b) => {
    if (a.nom < b.nom) {
      return -1;
    }
    if (a.nom > b.nom) {
      return 1;
    }
    return 0;
  };

  render() {
    const { observadors, idObservadorSeleccionat, idObservadorToken } = this.props;
    const idObservadorCerca = idObservadorSeleccionat || idObservadorToken;
    const { Option } = Select;
    const observadorsLlista = Array.isArray(observadors) ? observadors : [];
    const observadorsOrdenats = observadorsLlista
      .slice()
      .sort(this.ordenarArrayObjectesDesc);

    const llistaObservadorSeleccionat = observadorsLlista.filter(observador => {
      return observador.id === idObservadorCerca;
    });

    const nomObservadorSeleccionat =
      llistaObservadorSeleccionat && llistaObservadorSeleccionat.length > 0
        ? llistaObservadorSeleccionat[0].nom +
        " " +
        llistaObservadorSeleccionat[0].cognom1 +
        " " +
        llistaObservadorSeleccionat[0].cognom2
        : "";
    const valor =
      nomObservadorSeleccionat && idObservadorCerca
        ? `${nomObservadorSeleccionat}#&${idObservadorCerca}`
        : "Selecciona un observador...";

    return (
      <div className={styles.visualitzacioSelector}>
        <label htmlFor="id-observador">Seleccionar observador</label>

        <Select
          showSearch
          placeholder="Selecciona observador..."
          style={{ width: 250, maxHeight: 100 }}
          id="id-observador"
          onChange={this.handleOnChange}
          value={valor}
        >
          {observadorsOrdenats.map(observador => {
            const nomObservador =
              observador.nom +
              " " +
              observador.cognom1 +
              " " +
              observador.cognom2;
            return (
              <Option
                key={observador.key}
                value={nomObservador + "#&" + observador.key}
              >
                {nomObservador}
              </Option>
            );
          })}
        </Select>
      </div>
    );
  }
}

IntroduccioObservador.propTypes = {
  omplirIdObservadorIntroduccio: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  idObservadorSeleccionat: PropTypes.number,
  idObservadorToken: PropTypes.number,
  observadors: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.number.isRequired,
      nom: PropTypes.string.isRequired,
      cognom1: PropTypes.string.isRequired,
      cognom2: PropTypes.string.isRequired
    })
  )
};

const mapStateToProps = state => {
  return {
    idObservadorSeleccionat: getIdObservadorIntroduccio(state),
    observadors: getObservadorsAsArray(state)
  };
};

export default connect(mapStateToProps, { omplirIdObservadorIntroduccio })(
  IntroduccioObservador
);
